import styled, { css } from 'styled-components'

import { AccountSectionNavButton } from '@src/components/AccountSectionNavButton/AccountSectionNavButton'
import { breakpoints } from '@src/constants/breakpoints'

import { PrepSVG } from '../../components/SVGS/PrepSVG'
import { RejectSVG } from '../../components/SVGS/RejectSVG'
import { SmallSuccessTick } from '../../components/SVGS/SmallSuccessTick'
import { TimeSVG } from '../../components/SVGS/TimeSVG'

export const Container = styled.div``

export const Order = styled(AccountSectionNavButton)<{
  lastOrder: boolean
  active: boolean
}>`
  all: unset;
  display: flex;
  border-bottom: 2px solid #ebecf0;
  border-radius: 1px;
  cursor: pointer;
  padding-bottom: 16px;
  margin-bottom: 16px;

  ${props =>
    props.active &&
    css`
      background: #ebecf0;

      ${RestaurantLogo} {
        background: #fff;
      }
    `}
  width: 100%;

  &:hover {
    color: ${({ theme }) => theme.colors.brand};
  }
`

export const RestaurantLogo = styled.div<{
  imageUrl: string
}>`
  height: 72px;
  width: 72px;
  border-radius: 4px;
  background-color: #f6f6f9;
  background-size: cover;
  background-position: 50%;
  margin-right: 12px;

  ${props =>
    props.imageUrl &&
    css`
      background-image: url(${props.imageUrl});
    `};
`

export const OutletNameAndTotal = styled.div`
  display: flex;
  flex-direction: column;
  flex-grow: 1;
`

export const OutletName = styled.h4`
  margin: 4px 0px 2px 0px;
  font-weight: 700;
  font-size: 18px;
`
export const OrderedAt = styled.div`
  font-weight: 400;
  font-size: 12px;
`

export const OutletTotal = styled.div`
  margin: 8px 0 0 0;
  font-weight: 700;
  font-size: 14px;
`

export const OrderStatusContainer = styled.div`
  display: flex;
  align-items: flex-end;
  flex-shrink: 0;
  font-weight: 700;
  font-size: 14px;
  text-align: left;
`

export const OrderStatusSuccess = styled.span`
  display: flex;
  align-items: flex-end;
  flex-shrink: 0;
  color: ${({ theme }) => theme.colors.openStatus};
`

export const OrderStatusPending = styled.span`
  display: flex;
  align-items: flex-end;
  flex-shrink: 0;
  color: ${({ theme }) => theme.colors.preorderStatus};
`

export const OrderStatusRejected = styled.span`
  display: flex;
  align-items: flex-end;
  flex-shrink: 0;
  color: ${({ theme }) => theme.colors.danger};
`

export const NumberOfOrdersShown = styled.p`
  display: flex;
  margin: 0px;
  font-weight: 400;
  font-size: 14px;
  strong {
    margin: 0 5px;
  }
`

export const SuccessIcon = styled(SmallSuccessTick)`
  margin-left: 4px;
`

export const PendingIcon = styled(TimeSVG)`
  margin-left: 4px;
`

export const PreparingIcon = styled(PrepSVG)`
  margin-left: 4px;
`

export const RejectIcon = styled(RejectSVG)`
  margin-left: 4px;
`

export const YearsPickerContainer = styled.div`
  z-index: 0;
  height: 72px;
  display: flex;
  align-items: center;

  @media (min-width: ${breakpoints.largeTablet}px) {
    margin-top: 0;
  }
`

export const NoIdealStatePage = styled.div`
  height: 200px;
  display: flex;
  justify-content: center;
  text-align: center;
  padding: 32px;
  align-items: center;
  border: 2px solid #ebecf0;
  border-radius: 8px;
`

export const OrderInfoContainer = styled.div`
  display: flex;
  justify-content: space-between;
`

export const ButtonContainer = styled.div`
  margin-top: 16px;
`
